<template>
  <div class="main-container checkout-view">
    <div class="checkout-view-stepper">
      <div class="flex">
        <p
          class="stepper-number bg-black"
          :class="activeTab >= 1 ? 'bg-blue' : 'bg-opacity-25'"
        >1</p>
        <span
          class="pl-2 hidden lg:block"
          :class="activeTab >= 1 ? 'text-blue' : 'opacity-25'"
        >
          Product Summary
        </span>
      </div>
      <hr>
      <div class="flex">
        <p
          class="stepper-number bg-black"
          :class="activeTab >= 2 ? 'bg-blue' : 'bg-opacity-25'"
        >2</p>
        <span
          class="pl-2 hidden lg:block"
          :class="activeTab >= 2 ? 'text-blue' : 'opacity-25'"
        >Additional Services</span>
      </div>
      <hr>
      <div class="flex">
        <p
          class="stepper-number bg-black"
          :class="activeTab >= 3 ? 'bg-blue' : 'bg-opacity-25'"
        >3</p>
        <span
          class="pl-2 hidden lg:block"
          :class="activeTab >= 3 ? 'text-blue' : 'opacity-25'"
        >Select Address</span>
      </div>
      <hr>
      <div class="flex">
        <p
          class="stepper-number bg-black"
          :class="activeTab >= 4 ? 'bg-blue' : 'bg-opacity-25'"
        >4</p>
        <span
          class="pl-2 hidden lg:block"
          :class="activeTab >= 4 ? 'text-blue' : 'opacity-25'"
        >Select Payment Method</span>
      </div>
      <hr class="border-t border-black w-8 border-opacity-25">
      <div class="flex">
        <p
          class="stepper-number bg-black"
          :class="activeTab >= 5 ? 'bg-blue' : 'bg-opacity-25'"
        >5</p>
        <span
          class="pl-2 hidden lg:block"
          :class="activeTab >= 5 ? 'text-blue' : 'opacity-25'"
        >Order Summary</span>
      </div>
    </div>
    <div class="my-10 md:bg-smoke-100 rounded-lg">
      <div class="checkout-view-primary bg-smoke rounded-lg">
        <div class="border-b border-dark-b">
          <h2 class="text-xl md:text-2xl font-medium mr-6">
            {{ steps[activeTab - 1] }}
          </h2>
        </div>
        <div class="pt-12">
          <CartProductsTable
            v-if="activeTab === 1"
            :products="cartProducts"
            @itemRemovedFromCart="itemRemovedFromCart"
          />
          <AdditionalServices
            v-else-if="activeTab === 2"
            :services="additionalPurchase"
            :cartProducts="cartProducts"
            @changed="additionalPurchaseChanged"
          />
          <AddressSelection
            v-else-if="activeTab === 3"
            :sameAddresses="sameAddresses"
            :shippingAddressId="shippingAddressIdToken"
            :billingAddressId="billingAddressIdToken"
            :cartProducts="cartProducts"
            @changeShippingAddress="changeShippingAddress"
            @changeBillingAddress="changeBillingAddress"
            @sameBillingAddress="sameBillingAddress"
          />
          <PaymentMethodSelection
            v-else-if="activeTab === 4"
            :paymentMethod="paymentMethod"
            :selectedCardId="selectedCardId"
            :selectedAchId="selectedAchId"
            :govtProof="govtIdProof"
            :hasCustomization="isCustomizationSelected"
            :totalBill="grandTotal"
            :cartProducts="cartProducts"
            @changeMethod="changePaymentMethod"
            @cardSelected="onCardSelected"
            @achSelected="onAchSelected"
            @addGovtProof="addGovtProof"
          />
          <OrderSummaryTab
            v-else-if="activeTab === 5"
            :summary="getCheckoutSummary"
            :cartProducts="cartProducts"
          />
        </div>
        <div class="text-right pt-8" v-if="activeTab !== 5">
          <span class="font-semibold">Grand Total: {{ grandTotal | currency }}</span>
        </div>
        <div class="flex flex-wrap justify-end pt-8">
          <button
            v-if="activeTab !== 1"
            class="bg-dark-b px-12 py-2 rounded-full"
            :class="{'mb-4 md:mb-0': activeTab ===4}"
            @click="changeTab(-1)"
          >Back</button>
          <button
            class="new-app-btn bg-blue ml-4"
            :class="{'opacity-25': isButtonDisabled}"
            :disabled='isButtonDisabled'
            @click="proceedNext()"
          >{{ proceedButtonText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ProductDetails from '@/shared/mixins/ProductDetails'
import CartProductsTable from '@/shared/components/cart/CartProductsTable'
import AdditionalServices from '@/shared/components/checkout/AdditionalServices'
import AddressSelection from '@/shared/components/checkout/AddressSelection'
import PaymentMethodSelection from '@/shared/components/checkout/PaymentMethodSelection'
import OrderSummaryTab from '@/shared/components/checkout/OrderSummaryTab'

export default {
  name: 'Checkout',
  mixins: [ ProductDetails ],
  components: {
    CartProductsTable,
    AdditionalServices,
    AddressSelection,
    PaymentMethodSelection,
    OrderSummaryTab
  },
  data() {
    return {
      title: 'Products Summary',
      activeTab: 1,
      steps: [
        'Product Summary', 'Additional Services', 'Select Address', 'Select Payment Method', 'Order Summary'
      ],
      additionalPurchase: [],
      shippingAddressIdToken: null,
      billingAddressIdToken: null,
      paymentMethod: '',
      selectedCardId: null,
      selectedAchId: null,
      govtIdProof: null,
      has_customization: false,
      processing: false
    }
  },
  updated() {
    this.paymentMethod = this.grandTotal >= 200000 ? 'Offline' : this.paymentMethod
  },
  computed: {
    ...mapGetters ([
      'getUserCart',
      'getCheckoutSummary',
      'getReferralCode'
    ]),
    cartProducts() { return this.getUserCart },
    grandTotal() {
      let amount = this.subTotal
      amount = parseFloat(amount)

      if(this.additionalPurchase.includes('has_signed_up_for_drs'))
        amount += 723
      
      if(this.additionalPurchase.includes('has_purchased_insurance'))
        amount += (this.subTotal * (3/100))
      
      if(this.additionalPurchase.includes('has_purchased_inspection'))
        amount += (this.cartProducts.length * 296.8)

      return amount
    },
    isButtonDisabled() {
      if (this.processing) return true
      if (this.activeTab === 3) return !this.addressesSelected
      if (this.activeTab === 4) {
        let disable = true
        if (this.paymentMethod === '') {
          disable = true
        } else if (this.paymentMethod === 'CC' && this.selectedCardId === null) {
          disable = true
        } else if (this.paymentMethod === 'ACH' && this.selectedAchId === null) {
          disable = true
        } else { disable = false }
        if (!this.govtIdProof) { disable = true }
        return disable
      }
      return false
    },
    proceedButtonText() {
      if (this.processing) return 'Processing'
      if (this.activeTab === 4 ) return 'Proceed To Order Placement'
      if (this.activeTab === 5) return 'Place Order'
      return 'Continue'
    },
    addressesSelected() {
      return !!this.shippingAddressIdToken && !!this.billingAddressIdToken
    },
    sameAddresses() {
      return this.shippingAddressIdToken === this.billingAddressIdToken
    },
    cartIds() { return this.cartProducts.map(product => product.cartId) },
    isCustomizationSelected() {
      return this.additionalPurchase.includes('has_customization')
    }
  },
  methods: {
    ...mapActions ([
      'createCheckoutSummary',
      'placeOrder',
      'resetCart',
      'removeReferralCode'
    ]),
    proceedNext() {
      if (this.activeTab <= 3) { this.changeTab(1) }
      else if (this.activeTab === 4) { this.createOrderSummary() }
      else if (this.activeTab === 5) {
        if (this.processing) return
        this.processing = true
        this.confirmOrder()
      }
    },
    changeTab(val) { this.activeTab += val },
    changeBillingAddress(id) { this.billingAddressIdToken = id },
    changePaymentMethod(val) { this.paymentMethod = val },
    onCardSelected(val) { this.selectedCardId = val },
    onAchSelected(val) { this.selectedAchId = val },
    addGovtProof(file) { this.govtIdProof = file },
    sameBillingAddress(isSame) {
      this.billingAddressIdToken = isSame ? this.shippingAddressIdToken : null
    },
    changeShippingAddress(id, same) {
      this.shippingAddressIdToken = id
      if (same) this.billingAddressIdToken = id
    },
    additionalPurchaseChanged(val) {
      this.additionalPurchase = val
      if (this.isCustomizationSelected) this.paymentMethod = 'Offline'
    },
    async createOrderSummary() {
      var formData = new FormData()
      formData.set('cart_id_tokens', this.cartIds)
      formData.set('additional_purchase', this.additionalPurchase)
      formData.set('shipping_address_id_token', this.shippingAddressIdToken)
      formData.set('billing_address_id_token', this.billingAddressIdToken)
      formData.set('payment_method', this.paymentMethod)
      formData.set('credit_card_id', ((this.paymentMethod == 'CC') ? this.selectedCardId: ''))
      formData.set('ach_id', ((this.paymentMethod == 'ACH') ? this.selectedAchId: ''))
      formData.set('is_same_billing_address', this.sameAddresses)
      if (this.getReferralCode) {
        formData.set('referral_code_id_token', this.getReferralCode.referral_code_id_token)
      }
      formData.append("govt_id_proof", this.govtIdProof);

      const result = await this.createCheckoutSummary(formData)
      if (!result.error) {
        this.summary = result
        this.activeTab = 5
      }
    },
    async confirmOrder() {
      const result = await this.placeOrder(this.getCheckoutSummary.checkoutLink)
      this.processing = false
      if (result.order_reference_number) {
        var checkoutProducts = [];
        this.cartProducts.forEach((product) => {
          /*
          window.ga('ec:addProduct', {
              id: product.productId,                            // Transaction ID. Required.
              name: product.name,                       // Product name. Required. 
              sku: product.sku,                        // SKU/code.
              category: product.categoryName,         // Category or variation.
              quantity: product.quantity,
              price : this.calculateItemPrice(product),
              brand: product.brand
          });
        */
        checkoutProducts.push({
              id: product.productId,                            // Transaction ID. Required.
              name: product.name,                       // Product name. Required. 
              sku: product.sku,                        // SKU/code.
              category: product.categoryName,         // Category or variation.
              quantity: product.quantity,
              price : this.calculateItemPrice(product),
              brand: product.brand
          });
      });
      /*
      window.ga('ec:setAction','purchase', {
          'id': result.order_reference_number,            // A value of 1 indicates this action is first checkout step.
          'affiliation': 'BuyHive Store',
          'revenue': this.grandTotal   // Used to specify additional info about a checkout stage, e.g. payment method.
      });
      window.ga('send', 'pageview');
      */
      window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      window.dataLayer.push({
        'ecommerce': {
          'purchase': {
            'actionField': {
              'id': result.order_reference_number,                         // Transaction ID. Required for purchases and refunds.
              'affiliation': 'BuyHive Store',
              'revenue': this.grandTotal
            },
            'products': checkoutProducts,
          }
        }
      });
      
      this.$router.push({name: 'CheckoutSuccess', params: {
        id: result.order_reference_number
      }})
      this.resetCart()
      this.removeReferralCode()
      } else {
        this.$notify({ group: 'buyHive', type: 'error', text: result.message })
      }
    },
    itemRemovedFromCart() {
      if (!this.cartProducts.length) this.$router.push({name: 'Cart'})
    }
  }
}
</script>
<style lang="scss" scoped>
  .checkout-view {
    &-stepper {
      @apply p-5 rounded-lg bg-smoke flex justify-between items-center;
      .stepper-number {
        @apply  inline-block h-5 w-5 rounded-full text-white text-center text-sm;
      }
      hr {
        @apply border-t border-black w-10 border-opacity-25;
      }
    }
    &-primary {
      @apply p-5 mx-auto;
      @screen lg { @apply p-12 };
      @screen xl { @apply px-0; max-width: 1160px; }
    }
  }
</style>